import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Unauthorized() {
  const { signOut, session } = useAuth();
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 p-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow p-8 text-center">
        <h1 className="text-xl font-semibold text-bardin-ink">No access</h1>
        {session?.user?.email ? (
          <p className="text-slate-500 mt-2">
            <span className="font-mono">{session.user.email}</span> isn't on the
            Bardin team roster, or doesn't have permission for this page.
          </p>
        ) : (
          <p className="text-slate-500 mt-2">You don't have access to this area.</p>
        )}
        <div className="mt-6 flex justify-center gap-3">
          <Link
            to="/"
            className="px-4 py-2 rounded bg-slate-100 hover:bg-slate-200 text-slate-700"
          >
            Go home
          </Link>
          <button
            onClick={signOut}
            className="px-4 py-2 rounded bg-bardin-ink text-white hover:bg-slate-800"
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
